import Model, { attr, hasMany } from '@ember-data/model'

export default class SourceModel extends Model 
{
	@attr name;
	@attr host;
	
	@hasMany('dataset',{inverse: 'SourceId', async: true}) datasets;
}
